import { OdataManager } from '@/api/odata/odata-manager';
import { ConstructionArea } from '@/api/model/interfaces';

export default class ConstructionAreaOdata extends OdataManager<ConstructionArea> {}
